import {combineEpics} from 'redux-observable';
import {CREATE_INVOICE, GET_CARE_UNIT, LIST_EVENTS} from './ReportActionTypes';
import {catchError, map, switchMap} from 'rxjs/operators';
import config from 'react-global-configuration';
import {
    errorHandlingWithLogoutCheck,
    getJsonWithAuth,
    postJsonWithAuth,
    putJsonWithAuth
} from "../../../components/AjaxHelpers";
import {reportActions, reportSelectors} from "./index";
import {invoice} from './ReportSelectors';


export const reportOptionEpic = combineEpics(

  (action$, state$) => action$.ofType(CREATE_INVOICE).pipe(
    switchMap(action =>
      postJsonWithAuth({
        url: config.get('apiBaseUrl') + '/invoice/v1',
        body: {
          ...invoice(state$.value)
        },
        state: state$.value,
        responseType: 'blob', //maps to otherParams
      }).pipe(
        map(payload => reportActions.createInvoiceSuccess(payload)),
        catchError(error => errorHandlingWithLogoutCheck(error, [reportActions.createInvoiceFailure(error)]))
      )
    )
  ),
  (action$, state$) => action$.ofType(LIST_EVENTS).pipe(
    switchMap(action => {
      let filter = reportSelectors.eventListFilter(state$.value);
      let queryParams = new URLSearchParams({
        from: filter.from !== "" ? filter.from + 'T00:00:00.000Z' : "",
        before: filter.before !== "" ? filter.before + 'T00:00:00.000Z' : "",
        receivingOrganizationId: filter.careUnitOrganizationId,
        sendingOrganizationId: filter.opticianOrganizationId,
      });
      // Filter only transmission events for Fakturaunderlag
      const transmissionEventTypes = [
        'REFERRAL_TRANSMISSION_SUCCESS',
        'REFERRAL_TRANSMISSION_FAILED_CLIENT',
        'REFERRAL_TRANSMISSION_FAILED_SERVER',
        'REFERRAL_TRANSMISSION_FAILED_REST_CLIENT'
      ];
      transmissionEventTypes.forEach(t => queryParams.append('eventTypes', t));

      return getJsonWithAuth({
        url: config.get('apiBaseUrl') + '/events/v1?' + queryParams.toString(),
        state: state$.value
      }).pipe(
        map(payload => reportActions.listEventsSucceeded(payload)),
        catchError(response => errorHandlingWithLogoutCheck(response,
          [reportActions.listEventsFailed(response)],
          "Något gick fel när lista av händelser skulle hämtas."))
      )
    })
  ),
  (action$, state$) =>
    action$.ofType(GET_CARE_UNIT).pipe(
      switchMap((action) =>
        putJsonWithAuth({
          url: config.get("apiBaseUrl") + "/careUnits/v1/" + action.careUnitId,
          body: {
            username: action.username,
            role: action.role,
            organizationId: action.organizationId,
          },
          state: state$.value,
        }).pipe(
          map((payload) => reportActions.getCareUnitSucceeded(payload)),
          catchError((error) =>
            errorHandlingWithLogoutCheck(error, [
              reportActions.getCareUnitFailed(error),
            ])
          )
        )
      )
    ),


    (action$, state$) => action$.ofType(GET_CARE_UNIT).pipe(
      switchMap(action =>
          getJsonWithAuth({
              url: config.get('apiBaseUrl') + '/careUnits/v1/' + action.organizationId,
              state: state$.value
          }).pipe(
              map(payload => reportActions.getCareUnitSucceeded(payload)),
              catchError(error => errorHandlingWithLogoutCheck(error,
                  [reportActions.getCareUnitFailed(error)],
                  "Något gick fel när vårdenhetsdata skulle laddas."))
          )
      )
  ),
)